export const ACTION = '/Catalog/SubscribeProduct';